module.exports = __webpack_public_path__ + "img/max.31428034.png";